// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalRight__right___Zmcz3 {
    overflow-y: auto;
    flex-grow: 1;
    width: 32rem;
    height: 58.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalTemplate/ModalRight/ModalRight.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".right {\n    overflow-y: auto;\n    flex-grow: 1;\n    width: 32rem;\n    height: 58.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"right": `ModalRight__right___Zmcz3`
};
export default ___CSS_LOADER_EXPORT___;
